import { COUNTRIES_FETCH } from "../actions/countryActions";

const countryReducer = (state: any[] = [], action: any) => {
  switch (action.type) {
    case COUNTRIES_FETCH:
      return action.payload;
    default:
      return state;
  }
};

export default countryReducer;
